import createIcon from '../../createIcon';

/**
 * @component @name FormatOverline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM1Y1SDVWM0gxOVpNMTIgN0M4LjEzIDcgNSAxMC4xMyA1IDE0QzUgMTcuODcgOC4xMyAyMSAxMiAyMUMxNS44NyAyMSAxOSAxNy44NyAxOSAxNEMxOSAxMC4xMyAxNS44NyA3IDEyIDdaTTEyIDE4LjVDOS41MSAxOC41IDcuNSAxNi40OSA3LjUgMTRDNy41IDExLjUxIDkuNTEgOS41IDEyIDkuNUMxNC40OSA5LjUgMTYuNSAxMS41MSAxNi41IDE0QzE2LjUgMTYuNDkgMTQuNDkgMTguNSAxMiAxOC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatOverline = createIcon('FormatOverline', [
  [
    'path',
    {
      d: 'M19 3V5H5V3H19ZM12 7C8.13 7 5 10.13 5 14C5 17.87 8.13 21 12 21C15.87 21 19 17.87 19 14C19 10.13 15.87 7 12 7ZM12 18.5C9.51 18.5 7.5 16.49 7.5 14C7.5 11.51 9.51 9.5 12 9.5C14.49 9.5 16.5 11.51 16.5 14C16.5 16.49 14.49 18.5 12 18.5Z',
      key: '1fo5f8',
    },
  ],
]);

export default FormatOverline;
